import { getOffset } from './_getOffset';

export function stickyHeader() {
  const baseElement = document.querySelector('.js-header');

  let baseElementOffsetTop = '';

  const setSize = () => {
    const baseElementOffset = getOffset(baseElement);
    baseElementOffsetTop = baseElementOffset.top;
  }

  const scroller = () => {
    const scTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
    if(baseElementOffsetTop <= scTop) {
      document.body.classList.add('is-header-fixed');
    } else {
      document.body.classList.remove('is-header-fixed');
    }
  }

  window.addEventListener('resize', () => {
    setSize();
    scroller();
  });

  window.addEventListener('scroll', scroller);

  setSize();
  scroller();

  setInterval(() => {
    setSize();
    scroller();
  }, 2000)

  if(Typekit) {
    try {
      Typekit.load({
        active: function() {
          setTimeout(() => {
            setSize();
            scroller();
          }, 100);
        }
      })
    } catch(e) {}
  }
}